export { default as Ahmedabad } from "./Ahmedabad";
export { default as AIMagic } from "./AIMagic";
export { default as AlertTriangle } from "./AlertTriangle";
export { default as Apple } from "./Apple";
export { default as Bangalore } from "./Bangalore";
export { default as Behance } from "./Behance";
export { default as Clip } from "./Clip";
export { default as Delhi } from "./Delhi";
export { default as Edit } from "./Edit";
export { default as ExclamationEmailIcon } from "./ExclamationEmailIcon";
export { default as ExclamationPhoneIcon } from "./ExclamationPhoneIcon";
export { default as EyeOff } from "./EyeOff";
export { default as EyeOpen } from "./EyeOpen";
export { default as Facebook } from "./Facebook";
export { default as Google } from "./Google";
export { default as GraduationCap } from "./GraduationCap";
export { default as Hyderabad } from "./Hyderabad";
export { default as Kochi } from "./Kochi";
export { default as Link } from "./Link";
export { default as Lock } from "./Lock";
export { default as Lucknow } from "./Lucknow";
export { default as Mail } from "./Mail";
export { default as Mumbai } from "./Mumbai";
export { default as Pencil } from "./Pencil";
export { default as ProfileCorner } from "./ProfileCorner";
export { default as Pune } from "./Pune";
export { default as Rajasthan } from "./Rajasthan";
export { default as RightArrow } from "./RightArrow";
export { default as Shield } from "./Shield";
export { default as Sms } from "./Sms";
export { default as Spark } from "./Spark";
export { default as SuccessTick } from "./SuccessTick";
export { default as ThreeDots } from "./ThreeDots";
export { default as TickEmailIcon } from "./TickEmailIcon";
export { default as TickPhoneIcon } from "./TickPhoneIcon";
export { default as TriangleWarning } from "./TriangleWarning";
export { default as UpDoubleArrow } from "./UpDoubleArrow";
export { default as Whatsapp } from "./Whatsapp";
export { default as Instagram } from "./Instagram";
export { default as LinkedIn } from "./LinkedIn";
export { default as Twitter } from "./Twitter";
export { default as LoginFooterMail } from "./LoginFooterMail";
export { default as Phone } from "./Phone";
export { default as Xicon } from "./Xicon";
export { default as Youtube } from "./Youtube";
